import React from 'react';
import './client.css';
import safeImage from '../../../assets/fund_security_shield.png';

function ClientFundInsurance() {
  return (
    <section className="client-fund-insurance">
      <div className="content-wrapper">
        <div className="text-content">
          <h2 className="section-title">Your Funds, <span>Our Priority</span></h2>
          <p className="subtitle">Professional-grade security for your peace of mind.</p>
          
          <div className="description-text">
            <p>
              We maintain the highest standards of financial security through segregated client accounts, 
              strict regulatory compliance, and advanced security protocols. Your funds are held separately 
              from company assets with reputable tier-1 financial institutions, ensuring complete protection 
              and peace of mind for every trading decision you make.
            </p>
          </div>
          
          <button className="learn-more-btn">Learn About Our Security</button>
        </div>
        
        <div className="image-content">
          <img src={safeImage} alt="Financial security and fund protection" />
        </div>
      </div>
    </section>
  );
}

export default ClientFundInsurance;
